import {
  Button,
  Dialog,
  DialogBody,
  DialogHeading,
  GeCheckCircle,
  GeExclamationCircle,
  HStack,
  Icon,
  Progress,
  Text,
} from '@metservicedev/met-ui';
import React from 'react';
import { useNavigate } from 'react-router-dom';

export type SubmitState = { success: true } | { error: string; details: string };

type Props = {
  isSubmitting: boolean;
  submitState?: SubmitState;
  onClose: () => void;
};

export const SubmissionDialog: React.FC<Props> = ({
  isSubmitting,
  submitState,
  onClose,
}) => {
  const navigate = useNavigate();
  return (
    <Dialog
      open={isSubmitting || !!submitState}
      modal
      // Difficult to test this with RTL, cos close button has no testid, or
      // role, or anything useful. Plus, this should just be a modal, not a
      // dialog, anyway, so there shouldn't even be a close button! If only we
      // were using a proper ui library...
      // So just commenting out for now; close button can just be defunct. 🤷
      // onOpenChange={({ open }) => {
      //   if (!open && !isSubmitting) {
      //     onClose();
      //   }
      // }}
    >
      {isSubmitting && (
        <>
          <DialogHeading title="Submitting VONA..." />
          <DialogBody>
            <Progress />
          </DialogBody>
        </>
      )}
      {submitState && 'success' in submitState && submitState.success && (
        <>
          <DialogHeading title="VONA sent successfully!" />
          <DialogBody>
            <HStack justifyContent="center">
              <Icon size="2xl" color="icon.good" as={GeCheckCircle} />
            </HStack>
            <Button
              data-testid="button-accept-success"
              onClick={() => {
                onClose();
                navigate('/');
                navigate(0);
              }}
            >
              Go to current VONAs list
            </Button>
          </DialogBody>
        </>
      )}
      {submitState && 'error' in submitState && submitState.error && (
        <>
          <DialogHeading title="Sending VONA failed!" />
          <DialogBody>
            <HStack justifyContent="center">
              <Icon size="2xl" color="icon.error" as={GeExclamationCircle} />
            </HStack>
            <Text>{submitState.error}</Text>
            <Text size="xs">{submitState.details}</Text>
            <Button
              data-testid="button-accept-failure"
              onClick={onClose}
            >
              Okay
            </Button>
          </DialogBody>
        </>
      )}
    </Dialog>
  );
};
